package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.ContactNameType
import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.at.oss.kotlin.manual.storage.common.contactname.ContactName
import pt.lightweightform.kotlin.type.validator.ValidationCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
object ContactNameValidator {
    val contactNameSequencialValidate = fun(contactName: ContactName): List<ValidationError> {
        val errors = mutableListOf<ValidationError>()
        // type
        validateContactNameType(contactName.type ?: "<null>")?.also { errors.add(it) }

        // freeText
        validateRequiredStrIf(contactName.freeText, contactName.type == ContactNameType.FREE_TEXT.value)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.freeText)?.also { errors.add(it) }

        val isStructured = contactName.type == ContactNameType.STRUCTURED.value
        // //single
        // precedingTitle
        validateStructuredFieldProhibition(contactName.precedingTitle, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.precedingTitle)?.also { errors.add(it) }

        // firstName
        validateStructuredFieldProhibition(contactName.firstName, isStructured)?.also { errors.add(it) }
        validateRequiredStrIf(contactName.firstName, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.firstName)?.also { errors.add(it) }

        // lastNamePrefix
        validateStructuredFieldProhibition(contactName.lastNamePrefix, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.lastNamePrefix)?.also { errors.add(it) }

        // lastName
        validateStructuredFieldProhibition(contactName.lastName, isStructured)?.also { errors.add(it) }
        validateRequiredStrIf(contactName.lastName, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.lastName)?.also { errors.add(it) }

        // generalSuffix
        validateStructuredFieldProhibition(contactName.generalSuffix, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.generalSuffix)?.also { errors.add(it) }

        // maidenName
        validateStructuredFieldProhibition(contactName.maidenName, isStructured)?.also { errors.add(it) }
        FreeTextValidator.validateFreeText(contactName.maidenName)?.also { errors.add(it) }

        // //multiple
        // titles
        validateMultiStructuredFieldProhibition(contactName.titles.size, isStructured)?.also { errors.add(it) }
        errors.addAll(contactName.titles.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

        // middleNames
        validateMultiStructuredFieldProhibition(contactName.middleNames.size, isStructured)?.also { errors.add(it) }
        errors.addAll(contactName.middleNames.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

        // generationIdentifiers
        validateMultiStructuredFieldProhibition(contactName.generationIdentifiers.size, isStructured)?.also { errors.add(it) }
        errors.addAll(contactName.generationIdentifiers.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

        // suffixes
        validateMultiStructuredFieldProhibition(contactName.suffixes.size, isStructured)?.also { errors.add(it) }
        errors.addAll(contactName.suffixes.mapNotNull { FreeTextValidator.validateFreeText(it.name) })

        return errors
    }

    val validateContactNameType = fun(contactNameType: String): ValidationError? {
        // allowedValues
        return if (ContactNameType.values().none { it.value == contactNameType }) ValidationError(code = ValidationCodes.UNALLOWED_VALUE_CODE)
        else null
    }

    val validateStructuredFieldProhibition = fun(fieldValue: String, isStructured: Boolean): ValidationError? {
        return if (!isStructured && fieldValue.isNotBlank()) ValidationError(code = CustomErrorCodes.CONTACT_NAME_STRUCTURED_FIELDS_BUT_NOT_STRUCTURED.code)
        else null
    }

    val validateMultiStructuredFieldProhibition = fun(fieldValuesSize: Int, isStructured: Boolean): ValidationError? {
        return if (!isStructured && fieldValuesSize > 0) ValidationError(code = CustomErrorCodes.CONTACT_NAME_STRUCTURED_FIELDS_BUT_NOT_STRUCTURED.code)
        else null
    }
}
